import { Box, Typography } from '@mui/material';

interface LogoProps {
  size?: 'small' | 'medium' | 'large';
  showWordmark?: boolean;
  onClick?: () => void;
}

const sizeMap = {
  small: { icon: 28, fontSize: '1.125rem' },
  medium: { icon: 36, fontSize: '1.25rem' },
  large: { icon: 48, fontSize: '1.75rem' },
};

export default function Logo({ size = 'medium', showWordmark = true, onClick }: LogoProps) {
  const { icon, fontSize } = sizeMap[size];

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        cursor: onClick ? 'pointer' : 'default',
      }}
      onClick={onClick}
    >
      <Box
        component="img"
        src="/icon.svg"
        alt="AmnPass"
        sx={{
          width: icon,
          height: icon,
          flexShrink: 0,
        }}
      />
      {showWordmark && (
        <Typography
          variant="h6"
          component="span"
          sx={{
            fontSize,
            fontWeight: 700,
            color: 'primary.main',
            letterSpacing: '-0.02em',
          }}
        >
          AmnPass
        </Typography>
      )}
    </Box>
  );
}

